@if (hasGlobalError()) {
  @defer {
    @let error = globalErrors()[0];
    <shared-global-error
      data-testid="global-error"
      [title]="error?.title ?? undefined"
      [message]="error?.message ?? error?.code ?? 'SHARED.ERRORS.GLOBAL.MESSAGE'"
      [unknownError]="true"
      [globalErrorType]="'general-error'"
      [hasReload]="true"
      (reload)="reload()" />
  } @loading {
    <!-- Show nothing while loading the error component -->
  }
} @else {
  <router-outlet></router-outlet>
}
